import React, { Component } from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import config from '../../data/SiteConfig'
import WebPricingTable from '../components/UI/WebPricingTable'
import MobilePricingTable from '../components/UI/MobilePricingTable'

class PricingPage extends Component {
  render() {
    return (
      <div className="pricing-container">
        <Helmet title={`Pricing | ${config.siteTitle}`} />
        <PricingPageContainer>
          <PageHead>
            <h1>Pricing</h1>
            <h3>
              AppTree is used by software engineers to accelerate the creation
              of enterprise software solutions and by business customers for
              integrating with existing systems.
            </h3>
            <h3>
              AppTree is a Platform as a Service product and fees are based on
              usage. Usage is measured in transactions. For enterprises looking
              for annual pricing or pricing for complete systems, contact us at
              sales@apptree.cloud.
            </h3>
            <Divider />
          </PageHead>
          <WebPricingTable />
          <MobilePricingTable />
        </PricingPageContainer>
      </div>
    )
  }
}

const PricingPageContainer = styled.div`
  width: 100vw;
  padding: 100px;
  & > * {
    margin: auto;
    text-align: center;
  }

  @media screen and (max-width: 762px) {
    padding: 20px;
    & > * {
      margin: 10px;
    }
  }
`

const PageHead = styled.div`
  margin: 50px auto;
  text-align: center;
  h1,
  h3 {
    margin: auto;
    margin-bottom: 25px;
  }
  h1 {
    width: 80%;
  }
  h3 {
    width: 85%;
  }
`
const Divider = styled.div`
  border-bottom: 0.5px solid black;
  width: 60%;
  margin: 50px auto;
`
export default PricingPage



// WEBPACK FOOTER //
// ./src/pages/pricing.jsx